import { render, staticRenderFns } from "./SeoModelComponent.vue?vue&type=template&id=66fa658c&scoped=true"
import script from "./SeoModelComponent.vue?vue&type=script&lang=js"
export * from "./SeoModelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa658c",
  null
  
)

export default component.exports